module.exports = __webpack_public_path__ + "static/media/ganga.cddfd938.png";